/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */

// crop according to aspect
function getCrop(image, aspect = 16 / 9) {
  const width = image.width > image.height ? (image.height / image.width) * 100 : 100;
  const height = image.height > image.width ? (image.width / image.height) * 100 : 100;
  const x = width === 100 ? 0 : (100 - width) / 2;
  const y = height === 100 ? 0 : (100 - height) / 2;

  return {
    unit: '%',
    aspect,
    width,
    height,
    x,
    y,
  };
}

export default async function cropImage(image, { aspect, width, height }, file) {
  const crop = getCrop(image, aspect);

  const cropWidth = image.naturalWidth * (crop.width / 100);
  const cropHeight = image.naturalHeight * (crop.height / 100);
  const startX = image.naturalWidth * (crop.x / 100);
  const startY = image.naturalHeight * (crop.y / 100);
  let targetWidth = width || cropWidth;
  let targetHeight = height || cropHeight;

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;

  const ctx = canvas.getContext('2d');

  ctx.drawImage(image, startX, startY, cropWidth, cropHeight, 0, 0, targetWidth, targetHeight);

  /* // As Base64 string
  const base64Image = canvas.toDataURL('image/jpeg');
  return base64Image; */

  // As blob
  const blob = await new Promise(resolve => {
    return canvas.toBlob(
      blob => {
        resolve(blob);
      },
      file.type || 'image/jpeg',
      1, // quality
    );
  });

  return new File([blob], file.name, { type: file.type || 'image/png' });
}
